enum projects {
  KAZAN = 'kazan',
  BILLING = 'billing',
  BILLING_SPECIAL = 'special',
}

export default projects;
